import Carousel from './Carousel';
import Catalog from './Catalog';
import Footer from './Footer';

const Home = () => {
    return (
        <section>
            <Carousel />
            <Catalog />
            <Footer />
        </section>
    )
}

export default Home